import { render, staticRenderFns } from "./FamilyCategoriesIndex.vue?vue&type=template&id=6a17369c&scoped=true&"
import script from "./FamilyCategoriesIndex.vue?vue&type=script&lang=js&"
export * from "./FamilyCategoriesIndex.vue?vue&type=script&lang=js&"
import style0 from "./FamilyCategoriesIndex.vue?vue&type=style&index=0&id=6a17369c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a17369c",
  null
  
)

export default component.exports